export const SET_TRAINING_STATUS = 'SET_TRAINING_STATUS';
export const SET_TRAINING_SUCCESS = 'SET_TRAINING_SUCCESS';

export const setTrainingStatus = (status) => ({
  type: SET_TRAINING_STATUS,
  payload: status,
});

export const setTrainingSuccess = (success) => ({
  type: SET_TRAINING_SUCCESS,
  payload: success,
});
